export default {
  token: '',
  domain: '',
  bot_name: ''
}
